import { makeStyles, Theme as DefaultTheme } from '@material-ui/core/styles';
import { Styles } from '@material-ui/styles/withStyles';

export const createStylesHook = <Theme = DefaultTheme, Props extends {} = {}, ClassKey extends string = string>(
  styles: Styles<Theme, Props, ClassKey>
): ((props?: Props) => Record<ClassKey, string>) => makeStyles(styles);
